import VuexPersistence from "vuex-persist";
import Vuex from "vuex";
import Vue from "vue";
import ticketStore from "./modules/ticketStore";
import surveyStore from "./modules/surveyStore";
import cacheStore from "./modules/cacheStore";
import AnswerHistoryStore from "./modules/AnswerHistoryStore";
import localforage from "localforage";
import { isIndexDbSupported } from "./../../services/helper";

Vue.use(Vuex);

const plugins = [];

const DB_NAME = "MSM_LOOPDB";

export const ticketMut = [
  "addTicket",
  "replaceTicketList",
  "removeInactiveTickets",
  "updateTicket",
  "updateTicketFiles",
];

export const indexdblMut = ["addSurveyInstance", "changeQuestion"];
export const cacheMut = ["buildCache", "flushCache"];

if (process.env.NODE_ENV !== "test") {
  localforage.config({
    driver: [
      localforage.WEBSQL,
      localforage.INDEXEDDB,
      localforage.LOCALSTORAGE,
    ], // Use IndexDB if supported
    name: "vuex_MSM",
    version: 1.0,
    storeName: "VuexStore", // Should be alphanumeric, with underscores.
    description: "persitent Vuex store",
  });
  localforage
    .ready()
    .then(function () {
      // This code runs once localforage
      // has fully initialized the selected driver.
      console.debug("Modul: " + localforage.driver());
    })
    .catch(function (e) {
      console.error(e); // `No available storage method found.`
      // One of the cases that `ready()` rejects,
      // is when no usable storage driver is found
    });
  //console.log("Mode:" + localforage.driver());

  const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    modules: ["tickets", "cacheFlags"],
  });
  plugins.push(vuexLocal.plugin);

  /** 
   not working due to indexdb being async 
   https://github.com/championswimmer/vuex-persist#note-on-localforage-and-async-stores
   */
  const vuexdb = new VuexPersistence({
    storage: localforage,
    asyncStorage: true,
    modules: ["surveyAnswers"],
  });
  plugins.push(vuexdb.plugin);
}

export const store = new Vuex.Store({
  modules: {
    tickets: ticketStore,
    surveyAnswers: surveyStore,
    cacheFlags: cacheStore,
    AnswerHistory: AnswerHistoryStore,
  },

  mutations: {},
  actions: {},
  plugins,
});



// WEBPACK FOOTER //
// ./src/surveyjs/store/index.js